import Row from "@avinet/adaptive-ui-core/layout/Row";
import "./DisplayData.scss";

interface DisplayDataProps {
  children: React.ReactNode;
  className?: string;
}

export function DisplayData({ children, className }: DisplayDataProps) {
  return <Row className={`display-data ${className ?? ""}`}>{children}</Row>;
}
